import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

export const quotePartCostDiscountSchema = () =>
  yup.object().shape({
    discount: numberSchemaWithTransform()
      .label(t('labelCostDiscount'))
      .min(0)
      .max(100)
      .nullable()
      .required(getEmptyErrorMessage(t('labelCostDiscount'))),
  });
